import { render, staticRenderFns } from "./pasoscalificar.vue?vue&type=template&id=a065d424&"
import script from "./pasoscalificar.vue?vue&type=script&lang=js&"
export * from "./pasoscalificar.vue?vue&type=script&lang=js&"
import style0 from "./pasoscalificar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports